<div class="input-form-field">
  <div class="form-line">
    <div class="form-line-item">
      <mat-form-field [class.mat-form-field-invalid]="!isValid && !isDisabled" class="input-form" appearance="outline">
        <input
          matInput
          #epInput="ngModel"
          disableRipple
          type="text"
          class="input font-size-m"
          [(ngModel)]="inputText"
          [disabled]="isDisabled"
          (blur)="handleInputBlur($event.target.value)"
          [placeholder]="placeholder"
          autofocus="true"
          required
        />
        <ng-content select="[form-suffix]"></ng-content>
        <span *ngIf="suffix" matSuffix [class.disabled]="isDisabled">
          <app-svg-icon [src]="suffix.icon"></app-svg-icon>
        </span>
      </mat-form-field>
      <mat-error *ngIf="!isValid && errorMessage?.length > 0" class="ep-text-regular-14 input-field-error-message">{{ errorMessage | translate }}</mat-error>
    </div>
  </div>
</div>
